import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const InventoryAddEdit = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	if (outbounddata.TaskTypeCode == "GenentechInventory") {
		fileName = "Genentech Inventory";
	} else if (outbounddata.TaskTypeCode == "OctapharmaInventory") {
		fileName = "Octapharma Inventory";
	} else if (outbounddata.TaskTypeCode == "AptevoInventory") {
		fileName = "Aptevo Inventory";
	} else if (outbounddata.TaskTypeCode == "AllianceInventory") {
		fileName = "Alliance Inventory";
	} else if (outbounddata.TaskTypeCode == "AkornInventory") {
		fileName = "Akorn Inventory";
	}
	const inventorydata = JSON.parse(localStorage.getItem("inventory"));
	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [gridInventories, setGridInventories] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	const [gridShow, setGridShow] = useState(false);
	const [inventoryItem, setInventoryItem] = useState({});
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const [disableSaveAll, setDisableSaveAll] = useState(false);
	const initialvalues = {
		AvailableQuantity: "",
		Dc_ID_Key: "",
		DistributorName: "",
		FileProcessID: "",
		LineItemCount: "",
		NDC: "",
		QP: "",
		QR: "",
		QS: "",
		ReportingDate: "",
		UOM: "",
	};
	const [newInventories, setNewInventories] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",
			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
				</Fragment>
			),
		},
		{
			Header: "Dc_ID_Key",
			accessor: "Dc_ID_Key",
			filter: "Dc_ID_Key",
			sortType: "basic",
			key: true,
			width: 120,
		},
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			key: true,
			width: 250,
		},
		{
			Header: "NDC",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
			key: true,
			width: 180,
		},
		{
			Header: "Reporting Date",
			accessor: "ReportingDate",
			filter: "ReportingDate",
			sortType: "basic",
			key: true,
			width: 120,
		},
		{
			Header: "UOM",
			accessor: "UOM",
			filter: "UOM",
			sortType: "basic",
			key: true,
			width: 120,
		},
		{
			Header: "Available Quantity",
			accessor: "AvailableQuantity",
			filter: "AvailableQuantity",
			sortType: "basic",
			key: true,
			width: 80,
		},
		{
			Header: "Quantity Purchased",
			accessor: "QP",
			filter: "QP",
			sortType: "basic",
			key: true,
			width: 80,
		},
		{
			Header: "Quantity Received",
			accessor: "QR",
			filter: "QR",
			sortType: "basic",
			key: true,
			width: 80,
		},
		{
			Header: "Quantity Sold",
			accessor: "QS",
			filter: "QS",
			sortType: "basic",
			key: true,
			width: 80,
		},
		{
			Header: "LineItemCount",
			accessor: "LineItemCount",
			filter: "LineItemCount",
			sortType: "basic",
			// key:true,
			width: 80,
			disable: true,
		},
	];

	useEffect(() => {
		setGridInventories(inventorydata);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "AvailableQuantity" ||
			name === "QP" ||
			name === "QR" ||
			name === "QS" ||
			name === "LineItemCount" ||
			name === "NDC"
		) {
			const re = /^[\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setInventoryItem((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setInventoryItem((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	const newhandleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "AvailableQuantity" ||
			name === "QP" ||
			name === "QR" ||
			name === "QS" ||
			name === "LineItemCount" ||
			name === "NDC"
		) {
			const re = /^[\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewInventories((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setNewInventories((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	function deleteRecord(row) {
		let data = gridInventories.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridInventories(deletedData);
	}

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newInventories]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [inventoryItem]);

	const validateEditForm = () => {
		inventoryItem.LineItemCount = inventoryItem.LineItemCount
			? inventoryItem.LineItemCount
			: "";
		if (
			inventoryItem.Dc_ID_Key &&
			inventoryItem.Dc_ID_Key.toString().trim() !== "" &&
			inventoryItem.DistributorName &&
			inventoryItem.DistributorName.toString().trim() !== "" &&
			inventoryItem.NDC &&
			inventoryItem.NDC.toString().trim() !== "" &&
			inventoryItem.UOM &&
			inventoryItem.UOM.toString().trim() !== "" &&
			(inventoryItem.AvailableQuantity ||
				inventoryItem.AvailableQuantity === 0) &&
			inventoryItem.AvailableQuantity.toString().trim() !== "" &&
			(inventoryItem.QP || inventoryItem.QP === 0) &&
			inventoryItem.QP.toString().trim() !== "" &&
			(inventoryItem.QR || inventoryItem.QR === 0) &&
			inventoryItem.QR.toString().trim() !== "" &&
			(inventoryItem.QS || inventoryItem.QS === 0) &&
			inventoryItem.QS.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	const validateForm = () => {
		if (
			newInventories.Dc_ID_Key &&
			newInventories.Dc_ID_Key.toString().trim() !== "" &&
			newInventories.DistributorName &&
			newInventories.DistributorName.toString().trim() !== "" &&
			newInventories.NDC &&
			newInventories.NDC.toString().trim() !== "" &&
			newInventories.UOM &&
			newInventories.UOM.toString().trim() !== "" &&
			(newInventories.AvailableQuantity ||
				newInventories.AvailableQuantity === 0) &&
			newInventories.AvailableQuantity.toString().trim() !== "" &&
			(newInventories.QP || newInventories.QP === 0) &&
			newInventories.QP.toString().trim() !== "" &&
			(newInventories.QR || newInventories.QR === 0) &&
			newInventories.QR.toString().trim() !== "" &&
			(newInventories.QS || newInventories.QS === 0) &&
			newInventories.QS.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	function saveRowHandler() {
		setSubmitDisable(false);
		if (!editOrSaveInd) {
			if (outbounddata.TaskTypeCode === "GenentechInventory") {
				newInventories.ReportingDate = moment(
					newInventories.ReportingDate
						? newInventories.ReportingDate
						: new Date()
				).format("YYYY/MM/DD");
			} else {
				newInventories.ReportingDate = moment(
					newInventories.ReportingDate
						? newInventories.ReportingDate
						: new Date()
				).format("MM/DD/YYYY");
			}
			newInventories.ind = Object.assign({}, gridInventories.length + 1);
			newInventories.ind = gridInventories.length + 1;
			const ns = Object.assign({}, newInventories);
			gridInventories.unshift(ns);
			setaddShowConfirm(false);
			setNewInventories(initialvalues);
			newInventories.ind = 0;
		}
	}

	function editRowHandler() {
		setAddSubmitDisable(false);
		let indicator = 0;
		if (outbounddata.TaskTypeCode === "GenentechInventory") {
			inventoryItem.ReportingDate = moment(inventoryItem.ReportingDate).format(
				"YYYY/MM/DD"
			);
		} else {
			inventoryItem.ReportingDate = moment(inventoryItem.ReportingDate).format(
				"MM/DD/YYYY"
			);
		}
		if (editOrSaveInd) {
			gridInventories.filter((element, index) => {
				if (editIndex === index) {
					const inventoryTemp = Object.assign({}, inventoryItem);
					gridInventories[index] = inventoryTemp;
				}
			});
			indicator = 1;
		}

		if (indicator !== 0) {
			console.log(inventoryItem);
			setShowConfirm(false);
		}
	}

	const editReport = (inventories) => {
		setEditIndex(inventories.row.index);
		setInventoryItem(
			{
				...inventoryItem,
				...inventories.row.original,
			},
			setAddSubmitDisable(validateEditForm())
		);
		setShowConfirm(true);
		setEditOrSaveInd(true);
	};

	const saveRecords = () => {
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		setDisableSaveAll(true);
		gridInventories.map((element) => {
			element.FileProcessID = inventorydata[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.isEdited = true;
			element.version = 1;
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus === "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.Service_Task_Id = outbounddata.ServiceTaskID;

			element.DistributorAccount = "";
			element.EndofMonthInventory = "";
			element.LotNumber = "";
			element.ExpirationDate = new Date();
			element.UnitsOrVial = 4;
			element.TotalUnit = 4;
			element.Assigned_Customer_Key = "";
			element.Dc_ID_Qual = 0;
			element.NdcUpc_Qual = "";
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/ReversalOutbound852", gridInventories)
			.then((data) => {
				if (data.data === "") {
					setLoading(false);
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 500);
				}
			})
			.catch((e) => {
				setLoading(false);
				setDisableSaveAll(false);
			});
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					<Button variant="primary" type="button" onClick={() => saveRecords()}>
						Add Record
					</Button>
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridInventories, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>

			{/* Grid Section */}
			<Row>
				<Col md={12}>
					<span className="mb-4 h6">
						File Name: {outbounddata.File_Process_Name}
					</span>{" "}
					<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{gridInventories.length > 0 ? (
											<ReactTable
												columns={Gridcolumns}
												data={gridInventories}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>

			{/* Grid Footer Actions */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridInventories.length > 0 && (
						<Button
							variant="primary"
							type="button"
							disabled={disableSaveAll}
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			{/* Copyright Footer */}
			<Footer />

			{/* Add New Record Modal */}
			<Modal
				show={addshowConfirm}
				onHide={() => setaddShowConfirm(false)}
				backdrop="static"
				keyboard={false}
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>Add Record</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							<div className="card pt-2 mb-4">
								<div className="card-body">
									<Form>
										<Row>
											{Gridcolumns.map(function (i, index) {
												return (
													i.accessor !== "accessor" && (
														<Col md={3} key={index}>
															<Form.Group>
																<div className="date-picker ungroup-date-picker pos-rl">
																	<Form.Label htmlFor="StartDate">
																		{i.accessor !== "" ? i.Header : ""}
																		{i.key && (
																			<span className="err-msg">*</span>
																		)}
																	</Form.Label>
																	{i.Header.indexOf("Date") !== -1 && (
																		<IoMdCalendar className="icon date-icon" />
																	)}
																	{i.Header.indexOf("Date") !== -1 && (
																		<DatePicker
																			key={newInventories[i.accessor]}
																			selected={
																				newInventories[i.accessor]
																					? new Date(
																							moment(
																								newInventories[i.accessor]
																							).format(
																								outbounddata.TaskTypeCode ===
																									"GenentechInventory"
																									? "YYYY/MM/DD"
																									: "MM/DD/YYYY"
																							)
																					  )
																					: new Date()
																			}
																			onChange={(e) =>
																				setNewInventories((values) => ({
																					...values,
																					[i.accessor]: e,
																				}))
																			}
																			maxDate={new Date()}
																		/>
																	)}
																	{i.Header.indexOf("Date") === -1 && (
																		<Form.Control
																			required
																			type="text"
																			name={i.accessor}
																			value={newInventories[i.accessor]}
																			// key={inventoryItem[i.accessor]}
																			onChange={(e) => newhandleChange(e)}
																			disabled={i.disable}
																		/>
																	)}
																	<Form.Control.Feedback type="invalid">
																		Please enter Holiday Description.
																	</Form.Control.Feedback>
																</div>
															</Form.Group>
														</Col>
													)
												);
											})}
										</Row>
									</Form>
								</div>
							</div>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<div className="text-right mt-2">
						<Button
							type="submit"
							disabled={disableSubmit}
							onClick={() => saveRowHandler()}
						>
							<IoMdDoneAll className="icon btn-icon" />
							Save
						</Button>
						<Button
							variant="danger"
							className="ml-3 btn-sm"
							onClick={() => setaddShowConfirm(false)}
						>
							<IoIosClose className="icon btn-icon" />
							Cancel
						</Button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* Edit Existing Record Modal */}
			<Modal
				show={showCOnfirm}
				onHide={() => setShowConfirm(false)}
				backdrop="static"
				keyboard={false}
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>Edit Record</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12}>
							<div className="card pt-2 mb-4">
								<div className="card-body">
									<Form>
										<Row>
											{Gridcolumns.map(function (i, index) {
												return (
													i.accessor != "accessor" && (
														<Col md={3} key={index}>
															<Form.Group>
																<div className="date-picker ungroup-date-picker pos-rl">
																	<Form.Label htmlFor="StartDate">
																		{i.accessor !== "" ? i.Header : ""}
																		{i.key && (
																			<span className="err-msg">*</span>
																		)}
																	</Form.Label>
																	{i.Header.indexOf("Date") !== -1 && (
																		<IoMdCalendar className="icon date-icon" />
																	)}
																	{i.Header.indexOf("Date") !== -1 && (
																		<DatePicker
																			key={inventoryItem[i.accessor]}
																			selected={
																				inventoryItem[i.accessor]
																					? new Date(
																							moment(
																								inventoryItem[i.accessor]
																							).format(
																								outbounddata.TaskTypeCode ===
																									"GenentechInventory"
																									? "YYYY/MM/DD"
																									: "MM/DD/YYYY"
																							)
																					  )
																					: new Date()
																			}
																			onChange={(e) =>
																				setInventoryItem((values) => ({
																					...values,
																					[i.accessor]: e,
																				}))
																			}
																			maxDate={new Date()}
																		/>
																	)}
																	{i.Header.indexOf("Date") === -1 && (
																		<Form.Control
																			required
																			type="text"
																			name={i.accessor}
																			value={inventoryItem[i.accessor]}
																			// key={inventoryItem[i.accessor]}
																			onChange={(e) => handleChange(e)}
																			disabled={i.disable}
																		/>
																	)}
																</div>
															</Form.Group>
														</Col>
													)
												);
											})}
										</Row>
									</Form>
								</div>
							</div>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<div className="text-right mt-2">
						<Button
							disabled={addDisableSubmit}
							onClick={() => editRowHandler()}
						>
							<IoMdDoneAll className="icon btn-icon" />
							Edit Row
						</Button>
						<Button
							variant="danger"
							className="ml-3 btn-sm"
							onClick={() => setShowConfirm(false)}
						>
							<IoIosClose className="icon btn-icon" />
							Cancel
						</Button>
					</div>
				</Modal.Footer>
			</Modal>
		</section>
	);
};

export default InventoryAddEdit;
